export default {
  limit: Infinity,
  total: -Infinity,
  sheetName: 'Sheet',
  align: 'auto',
  $$fileName: '', // 支持数组或者字符串
  isUsingNewMethod: false,
  dataKey: ['list'],
  fParams: {},
};
